function array_sample(data) {
    const array_length = data.length;
    if (array_length === 0) {
        return;
    }
    
    const index = Math.floor(Math.random() * array_length);
    const result = data[index];
    
    // Remove the item from the list so we don't draw it again.
    data.splice(index, 1);

    return result;
}

function get_n_random(n, data) {
    let results = [];

    // Limit is n or data.length, whichever is smaller.
    let limit = (n > data.length) ? data.length : n;

    for(let i = 0; i < limit; i++) {
        const random_item = array_sample(data);
        results.push(random_item);      
    }

    return results;
}

function shuffle(data) {
    let shuffled = data
    .map(value => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value)

    return shuffled;
}

function learning_object_title_comparator(a, b) {
    if (a.title < b.title) {
        return -1;
    }

    if (a.title > b.title) {
        return 1;
    }

    return 0;
}

function title_sort_learning_objects(learning_object_list) {
    if (learning_object_list === null) {
        return learning_object_list;
    }

    return learning_object_list.sort(learning_object_title_comparator);
}

function learning_object_created_comparator(a, b) {
    if (a.created < b.created) {
        return -1;
    }

    if (a.created > b.created) {
        return 1;
    }

    return 0;
}

function created_sort_learning_objects(learning_object_list) {
    if (learning_object_list === null) {
        return learning_object_list;
    }

    return learning_object_list.sort(learning_object_created_comparator);
}

export {
	array_sample,
    get_n_random,
    shuffle,
    title_sort_learning_objects,
    created_sort_learning_objects,
}